module.exports = __webpack_public_path__ + "img/pac-man-min.d75b0b92.png";